const variants = (theme: any) => ({
  primary: {
    backgroundColor: "cta-primary-background-color-default",
    color: "cta-primary-text-color-default",
    "&:not([disabled]):focus, &:not([disabled]):hover": {
      backgroundColor: "cta-primary-background-color-hover",
    },
  },
  "primary-gradient": {
    backgroundImage: "linear-gradient(253deg, #21c9f3, #2196f3)",
    boxShadow: "0 2px 9px 0 rgba(15, 156, 246, 0.5)",
    color: "cta-primary-text-color-default",
    "&:not([disabled]):focus, &:not([disabled]):hover": {
      backgroundImage: "linear-gradient(258deg, #2196f3, #21c9f3)",
    },
  },
  secondary: {
    backgroundColor: "transparent",
    color: "cta-secondary-text-color-default",
    border: "2px solid",
    borderColor: "cta-secondary-border-color-default",
    "&:not([disabled]):focus, &:not([disabled]):hover": {
      color: "cta-secondary-text-color-hover",
      borderColor: "cta-secondary-border-color-hover",
    },
  },
  "secondary-white": {
    backgroundColor: "transparent",
    color: "white",
    border: "2px solid",
    borderColor: "white",
  },
  tertiary: {
    backgroundColor: "transparent",
    color: "cta-tertiary-text-color-default",
    border: "none",
    "&:not([disabled]):focus, &:not([disabled]):hover": {
      color: "cta-secondary-text-color-hover",
      borderColor: "cta-tertiary-text-color-hover",
    },
    fontWeight: "normal",
    textDecoration: "underline",
  },
  button: {
    backgroundColor: "background-default-color",
    boxShadow: `${theme.shadows.default}, 0 0 2px #f1f1f1`,
    color: "cta-button-text-color-default",
    border: "2px solid transparent",
    height: "42px",
    "&": {
      svg: {
        fill: "text-color-hover",
      },
    },
    "&:not([disabled]):focus, &:not([disabled]):hover": {
      color: "cta-button-text-color-hover",
      borderColor: "cta-button-border-color-hover",
    },
    "&:not([disabled]).active": {
      "&:hover": {
        outline: "none",
      },
    },
    "&:not([disabled]):active, &:not([disabled]).active": {
      "svg > *": {
        fill: "text-color-over-background",
      },
      outline: "none",
      color: "text-color-over-background",
      backgroundColor: "cta-button-background-color-active",
      boxShadow: "none",
    },
  },
});
export default variants;
